(() => {
  if (window.__CHS_CART_LINE_LIMIT_LOADED__) return;
  window.__CHS_CART_LINE_LIMIT_LOADED__ = true;

  const LIMITED_VARIANT_IDS = ['53028258119998'];
  const MAX_QUANTITY = 1;
  const CART_SYNC_EVENT = 'chs:cart-updated';

  function getShopifyRoot() {
    return window.Shopify &&
      window.Shopify.routes &&
      window.Shopify.routes.root
      ? window.Shopify.routes.root
      : '/';
  }

  function getCartUrl() {
    return `${getShopifyRoot()}cart.js`;
  }

  function getCartChangeUrl() {
    if (window.routes && window.routes.cart_change_url) {
      return window.routes.cart_change_url;
    }

    return `${getShopifyRoot()}cart/change.js`;
  }

  function isLimitedVariantId(variantId) {
    return LIMITED_VARIANT_IDS.includes(String(variantId));
  }

  function dispatchCartSyncEvent(detail = {}) {
    document.dispatchEvent(
      new CustomEvent(CART_SYNC_EVENT, {
        bubbles: true,
        detail
      })
    );

    document.dispatchEvent(
      new CustomEvent('cartUpdated', {
        bubbles: true,
        detail
      })
    );

    document.dispatchEvent(
      new CustomEvent('cart:updated', {
        bubbles: true,
        detail
      })
    );
  }

  function getLineFromInput(input) {
    if (!input) return null;

    const index = input.dataset.index;
    if (index) return Number(index);

    const cartItem = input.closest('.cart-item');
    if (!cartItem) return null;

    const id = cartItem.getAttribute('id') || '';
    const match = id.match(/(\d+)$/);

    return match ? Number(match[1]) : null;
  }

  async function fetchCart() {
    const response = await fetch(getCartUrl(), {
      headers: {
        Accept: 'application/json'
      },
      credentials: 'same-origin'
    });

    if (!response.ok) {
      throw new Error(`cart.js failed with status ${response.status}`);
    }

    return response.json();
  }

  async function changeCartLine(line, quantity) {
    if (!line) return null;

    const response = await fetch(getCartChangeUrl(), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      credentials: 'same-origin',
      body: JSON.stringify({
        line: Number(line),
        quantity: Number(quantity)
      })
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(
        data.description ||
          data.message ||
          `Cart quantity update failed with status ${response.status}.`
      );
    }

    dispatchCartSyncEvent({
      source: 'chs-cart-line-limit',
      line: Number(line),
      quantity: Number(quantity),
      cart: data
    });

    return data;
  }

  async function normalizeCartJson() {
    try {
      const cart = await fetchCart();

      if (!cart || !Array.isArray(cart.items)) return;

      let changed = false;

      for (let index = 0; index < cart.items.length; index += 1) {
        const item = cart.items[index];

        if (
          isLimitedVariantId(item.variant_id) &&
          Number(item.quantity) > MAX_QUANTITY
        ) {
          await changeCartLine(index + 1, MAX_QUANTITY);
          changed = true;
        }
      }

      if (changed) {
        dispatchCartSyncEvent({
          source: 'chs-cart-line-limit-normalize'
        });
      }
    } catch (error) {
      console.warn('CHS cart line limit normalization failed:', error);
    }
  }

  function lockQuantityInput(input) {
    if (!input) return;

    const variantId = input.dataset.quantityVariantId;

    if (!isLimitedVariantId(variantId)) return;

    input.setAttribute('max', String(MAX_QUANTITY));
    input.setAttribute('data-max', String(MAX_QUANTITY));
    input.setAttribute('value', String(MAX_QUANTITY));
    input.value = String(MAX_QUANTITY);
    input.readOnly = true;

    const quantityWrapper =
      input.closest('quantity-input') || input.closest('.quantity');

    const cartItem =
      input.closest('.cart-item') ||
      input.closest('[id^="CartItem-"]') ||
      input.closest('[id^="CartDrawer-Item-"]');

    if (quantityWrapper) {
      quantityWrapper.classList.add('chs-limited-quantity');
    }

    if (cartItem) {
      cartItem.classList.add('chs-limited-cart-item');
    }

    const plusButton = quantityWrapper
      ? quantityWrapper.querySelector('.quantity__button[name="plus"]')
      : null;

    if (plusButton) {
      plusButton.classList.add('disabled');
      plusButton.setAttribute('disabled', 'disabled');
      plusButton.setAttribute('aria-disabled', 'true');
      plusButton.setAttribute('tabindex', '-1');
    }
  }

  function lockAllQuantityInputs() {
    document
      .querySelectorAll('.quantity__input[data-quantity-variant-id]')
      .forEach((input) => {
        lockQuantityInput(input);
      });
  }

  async function forceInputBackToOne(input) {
    if (!input) return;

    const variantId = input.dataset.quantityVariantId;

    if (!isLimitedVariantId(variantId)) return;

    const requestedQuantity = Number(input.value || 0);

    input.value = String(MAX_QUANTITY);
    input.setAttribute('value', String(MAX_QUANTITY));
    lockQuantityInput(input);

    if (requestedQuantity <= MAX_QUANTITY) {
      dispatchCartSyncEvent({
        source: 'chs-cart-line-limit-input-reset',
        variantId
      });
      return;
    }

    const line = getLineFromInput(input);

    try {
      await changeCartLine(line, MAX_QUANTITY);
    } catch (error) {
      console.error('CHS failed to force limited cart item quantity:', error);
    }
  }

  function scheduleCartSync() {
    setTimeout(() => {
      lockAllQuantityInputs();
      normalizeCartJson();
      dispatchCartSyncEvent({
        source: 'chs-cart-line-limit-scheduled-sync-300'
      });
    }, 300);

    setTimeout(() => {
      lockAllQuantityInputs();
      normalizeCartJson();
      dispatchCartSyncEvent({
        source: 'chs-cart-line-limit-scheduled-sync-900'
      });
    }, 900);

    setTimeout(() => {
      lockAllQuantityInputs();
      normalizeCartJson();
      dispatchCartSyncEvent({
        source: 'chs-cart-line-limit-scheduled-sync-1600'
      });
    }, 1600);
  }

  document.addEventListener(
    'click',
    (event) => {
      const plusButton = event.target.closest('.quantity__button[name="plus"]');

      if (!plusButton) return;

      const quantityWrapper =
        plusButton.closest('quantity-input') || plusButton.closest('.quantity');

      const input = quantityWrapper
        ? quantityWrapper.querySelector(
            '.quantity__input[data-quantity-variant-id]'
          )
        : null;

      if (!input) return;

      const variantId = input.dataset.quantityVariantId;

      if (!isLimitedVariantId(variantId)) return;

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      input.value = String(MAX_QUANTITY);
      input.setAttribute('value', String(MAX_QUANTITY));
      lockQuantityInput(input);

      dispatchCartSyncEvent({
        source: 'chs-cart-line-limit-plus-blocked',
        variantId
      });
    },
    true
  );

  document.addEventListener(
    'change',
    (event) => {
      const input = event.target.closest(
        '.quantity__input[data-quantity-variant-id]'
      );

      if (!input) return;

      forceInputBackToOne(input);
    },
    true
  );

  document.addEventListener(
    'input',
    (event) => {
      const input = event.target.closest(
        '.quantity__input[data-quantity-variant-id]'
      );

      if (!input) return;

      const variantId = input.dataset.quantityVariantId;

      if (!isLimitedVariantId(variantId)) return;

      input.value = String(MAX_QUANTITY);
      input.setAttribute('value', String(MAX_QUANTITY));
      lockQuantityInput(input);
    },
    true
  );

  document.addEventListener(
    'click',
    (event) => {
      const removeButton = event.target.closest(
        [
          'cart-remove-button',
          '.cart-remove-button',
          '.cart-item__remove',
          '.cart-remove',
          'a[href*="/cart/change"]',
          'a[href*="quantity=0"]',
          'button[name="remove"]',
          'button[name="minus"]'
        ].join(',')
      );

      if (!removeButton) return;

      scheduleCartSync();
    },
    true
  );

  document.addEventListener('cartUpdated', () => {
    setTimeout(() => {
      lockAllQuantityInputs();
      normalizeCartJson();
    }, 150);
  });

  document.addEventListener('cart:updated', () => {
    setTimeout(() => {
      lockAllQuantityInputs();
      normalizeCartJson();
    }, 150);
  });

  document.addEventListener('DOMContentLoaded', () => {
    lockAllQuantityInputs();
    normalizeCartJson();
    scheduleCartSync();
  });

  window.addEventListener('pageshow', () => {
    lockAllQuantityInputs();
    normalizeCartJson();
  });

  const observer = new MutationObserver(() => {
    lockAllQuantityInputs();
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();